module.exports = __webpack_public_path__ + "static/media/glitch-light1.feaa4f04.webp";